import { gql } from '@apollo/client';
import { CODE_FRAGMENT, QUANTITY_FRAGMENT } from '../../shared/fragments';

export const FETCH_VITALS_QUERY = gql`
  query fetchAllVitals($groupBy: vitalsGroupByEnum, $sourceUrl: String) {
    fetchAllVitals(groupBy: $groupBy, sourceUrl: $sourceUrl) {
      collectedDate
      type {
        key
        value
      }
      vitalsList {
        effectiveDateTime
        id
        code {
          ...code
        }
        valueString
        valueQuantity {
          ...quantity
        }
        component {
          code {
            ...code
          }
          valueQuantity {
            ...quantity
          }
        }
      }
    }
  }
  ${CODE_FRAGMENT}
  ${QUANTITY_FRAGMENT}
`;
